import {
    Alert,
    Checkbox,
    Collapse,
    FormControlLabel,
    FormGroup,
    Switch,
    TextField,
} from '@mui/material'
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { useState } from 'react'
import {
    dropEndDateValid,
    dropStartDateValid,
} from '../editor/DropCreatorUtils'
import { DropAlert } from './DropAlert'
import { DropPaper } from './DropPaper'

export const DropStartEndDateEditor = ({
    dropStartDate,
    setDropStartDate,
    dropStartDateEnabled,
    setDropStartDateEnabled,
    dropEndDate,
    setDropEndDate,
    dropEndDateEnabled,
    setDropEndDateEnabled,
    isPremint = false,
}) => {
    const [use24hrFormat, setUse24hrFormat] = useState(false)
    return (
        <DropPaper
        expandable
            id={'DropStartEndDateEditor'}
            title="Start and End Date / Time"
            error={
                (dropStartDateEnabled &&
                    !dropStartDateValid(dropStartDateEnabled, dropStartDate)) ||
                (dropEndDateEnabled &&
                    !dropEndDateValid(
                        dropEndDateEnabled,
                        dropStartDateEnabled,
                        dropStartDate,
                        dropEndDate,
                    ))
            }
        >
            <div className="my-5">
                <div className="flex flex-wrap w-full mb-5">
                    <div className="mb-2 sm:my-auto">
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={dropStartDateEnabled}
                                        onChange={(e) =>
                                            setDropStartDateEnabled(
                                                e.target.checked,
                                            )
                                        }
                                    />
                                }
                                label="Set Start Date and Time"
                            />
                        </FormGroup>
                    </div>
                    <Collapse in={dropStartDateEnabled}>
                        <div>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DateTimePicker
                                    label="Start Date and Time (Your local timezone)"
                                    value={dropStartDate}
                                    onChange={(e) =>
                                        setDropStartDate(
                                            new Date(e.setSeconds(0)),
                                        )
                                    }
                                    ampm={!use24hrFormat}
                                    minDateTime={new Date()}
                                    renderInput={(params) => (
                                        <TextField {...params} />
                                    )}
                                />
                            </LocalizationProvider>
                        </div>
                    </Collapse>
                </div>
                <div className="flex flex-wrap">
                    <div className="mb-2 sm:my-auto">
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={dropEndDateEnabled}
                                        onChange={(e) =>
                                            setDropEndDateEnabled(
                                                e.target.checked,
                                            )
                                        }
                                    />
                                }
                                label="Set End Date and Time"
                            />
                        </FormGroup>
                    </div>
                    <Collapse in={dropEndDateEnabled}>
                        <div>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DateTimePicker
                                    label="End Date and Time (Your local timezone)"
                                    value={dropEndDate}
                                    onChange={(e) =>
                                        setDropEndDate(
                                            new Date(e.setSeconds(0)),
                                        )
                                    }
                                    ampm={!use24hrFormat}
                                    // End time must be at least one hour after start time
                                    minDateTime={new Date()}
                                    renderInput={(params) => (
                                        <TextField {...params} />
                                    )}
                                />
                            </LocalizationProvider>
                        </div>
                    </Collapse>
                </div>
            </div>

            <Collapse in={dropStartDateEnabled || dropEndDateEnabled}>
                <div className="mb-5">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={use24hrFormat}
                                    onChange={() => {
                                        setUse24hrFormat(!use24hrFormat)
                                    }}
                                />
                            }
                            label="Use 24-hour format"
                        />
                    </FormGroup>
                </div>
            </Collapse>

            <DropAlert
                condition={!dropStartDateEnabled && isPremint}
                severity="warning"
            >
                This is a premint drop, and you will have to add NFTs to this
                drop after creating it. If you do not set a start date and time,
                the drop will go live immediatelty, without any assets. We
                therefore recommend setting a start date at least a couple of
                minutes in the future so you still have time to add your NFTs
                before the drop goes live!
            </DropAlert>

            <Collapse
                in={
                    dropStartDateEnabled &&
                    !dropStartDateValid(dropStartDateEnabled, dropStartDate)
                }
            >
                <div className="mb-5">
                    <Alert severity="error">
                        The start date must be in the future
                    </Alert>
                </div>
            </Collapse>

            <Collapse
                in={
                    dropEndDateEnabled &&
                    !dropEndDateValid(
                        dropEndDateEnabled,
                        dropStartDateEnabled,
                        dropStartDate,
                        dropEndDate,
                    )
                }
            >
                <div className="mb-5">
                    <Alert severity="error">
                        The end date must be{' '}
                        {dropStartDateEnabled
                            ? 'after the start date'
                            : 'in the future'}
                    </Alert>
                </div>
            </Collapse>
        </DropPaper>
    )
}
